module.exports = __webpack_public_path__ + "img/gc_fonce_1909.03347501.jpg";